export const INTEGRITY_MONITORING_AVAILABLE_LABEL =
  'Integrity monitoring for AI interviews and assessments';

export const ASSESSMENT_INTEGRITY_MONITORING_LABEL =
  'Monitor new assessment stages by default';

export const AI_INTERVIEW_INTEGRITY_MONITORING_LABEL =
  'Monitor new AI interview stages by default';

export const getStageDefaultNotificationMessage = (
  stageKind: 'assessment' | 'AI interview',
  isEnabled: boolean
) =>
  `The change will turn integrity monitoring ${
    isEnabled ? 'on' : 'off'
  } for new ${stageKind} stages that recruiters add in the role wizard or from a hiring process template. It does not change existing stages or stages created in Admin, and recruiters can still change it on each stage.`;

export const SWITCH_OFF_NOTIFICATION_MESSAGE =
  'Turning integrity monitoring off also turns off both defaults below.';

export const INTEGRITY_MONITORING_DATA_TEST_ID = 'integrity-monitoring-form';
